/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './content-item-row.scss';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The eyebrow content of content item row.
 *
 * @element c4d-content-item-row-eyebrow
 */
@customElement(`${c4dPrefix}-content-item-row-eyebrow`)
class C4DContentItemRowEyebrow extends StableSelectorMixin(LitElement) {
  /**
   * The shadow slot this eyebrow content should be in.
   */
  @property({ reflect: true })
  slot = 'eyebrow';

  render() {
    return html` <slot></slot> `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--content-item-row-eyebrow`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static styles = styles;
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentItemRowEyebrow;
